<template>
  <div ref="chartsData" class="chartsData"></div>
</template>

<script>
export default {
    name:"OnlineStatistics",
    data(){
        return{
            chartsData:'',
            types:[
                {name: 'JS Heap', color: '#7b9ce1'},
                {name: 'Documents', color: '#bd6d6c'},
                {name: 'Nodes', color: '#75d874'},
            ],
            data:[],
            categories:['离线','在线','异常'],
        }
    },
    methods:{
        getOnlineData(){
            let _this = this;
            this.categories.forEach(function (category, index) {
                var duration = Math.round(Math.random() * 10000);
                _this.data.push({
                    name: _this.types.name,
                    value: [
                        index,
                        duration
                    ],
                    itemStyle: {
                        normal: {
                            color: _this.types.color
                        }
                    }
                });
            });
            this.getChartData()
        },
        renderItem(params, api) {
            // console.log(params,api)
            var categoryIndex = api.value(0);
            var start = api.coord([api.value(1), categoryIndex]);
            var end = api.coord([api.value(2), categoryIndex]);
            var height = api.size([0, 1])[1] * 0.6;

            var rectShape = this.$echarts.graphic.clipRectByRect({
                x: start[0],
                y: start[1] - height / 2,
                width: end[0] - start[0],
                height: height
            }, {
                x: params.coordSys.x,
                y: params.coordSys.y,
                width: params.coordSys.width,
                height: params.coordSys.height
            });

            return rectShape && {
                type: 'rect',
                transition: ['shape'],
                shape: rectShape,
                style: api.style()
            };
        },
        getChartData(){
            let _this = this;
            console.log(this.data)
            this.chartsData = this.$echarts.init(this.$refs.chartsData);
            window.addEventListener('resize', function () { _this.chartsData.resize() })
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: function (params) {
                        return  params[0].axisValue + ': ' + params[0].value[1] + ' ms';
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    // min: this.startTime,
                    // scale: true,
                    // axisLabel: {
                    //     formatter: function (val) {
                    //         return Math.max(0, val - _this.startTime) + ' ms';
                    //     }
                    // },
                    boundaryGap: [0, 0.01],
                },
                yAxis: {
                    type: 'category',
                    data: this.categories
                },
                series: [
                   {
                        type: 'custom',
                        renderItem: this.renderItem,
                        itemStyle: {
                            opacity: 0.8
                        },
                        encode: {
                            x: [1, 2],
                            y: 0
                        },
                        data: this.data
                   }
                ]
            };
            this.chartsData.setOption(option);
        }
    },
    mounted(){
        this.getOnlineData()
    }
}
</script>

<style scoped>
.chartsData{
    width: 100%;
    height: 220px;
}
</style>